import { PureComponent } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Segment } from 'semantic-ui-react';
import { isEmpty } from '../../../../utils/lodash';
import { ActivityOutcomeRatings } from '../../../../components/charts/ActivityOutcomeRatings';
import '../activity.scss';

class MeasureEvaluation extends PureComponent {
  state = { hasData: true };

  render() {
    const {
      t,
      evaluation,
      currentActivity,
      selfAssessed,
      onHasData,
      prefetchedData,
    } = this.props;
    const { hasData } = this.state;

    if (isEmpty(evaluation)) return null;

    // Manager/self-assessed responses should never show the individual rate of change charts...
    const visibleModes = selfAssessed
      ? ['trend']
      : [
          evaluation?.trendInReport !== false ? 'trend' : null,
          evaluation?.individualInReport !== false ? 'individual' : null,
        ].filter(Boolean);

    return (
      <Segment
        className="report-activity-seg"
        basic
        style={
          hasData && visibleModes.length > 0 ? undefined : { display: 'none' }
        }
      >
        <div className="report-activity-div">
          <div className="graph-div">
            <ActivityOutcomeRatings
              activityId={currentActivity?.id}
              outcomeId={evaluation?.outcomeId}
              evaluationPlanIds={[evaluation?.evaluationPlanId]}
              prefetchedData={prefetchedData}
              showIncludeToggle={false}
              showProse={false}
              visibleModes={visibleModes}
              reportMode
              hideNoDataMessage
              onHasData={(hasData) => {
                this.setState({ hasData });
                onHasData?.(hasData);
              }}
            />
            {evaluation?.reportNarrative && (
              <div
                className="or__prose"
                dangerouslySetInnerHTML={{ __html: evaluation.reportNarrative }}
              />
            )}
          </div>
        </div>
      </Segment>
    );
  }
}

const mapStateToProps = (state) => {
  const { currentActivity } = state.activity;
  return {
    currentActivity,
  };
};

MeasureEvaluation = connect(mapStateToProps)(MeasureEvaluation);

const MeasureEvaluationWithTranslation = withTranslation()(MeasureEvaluation);

export { MeasureEvaluationWithTranslation as MeasureEvaluation };
